import React from "react";
import {
  countObjectUseCase,
  deleteObjectUseCase,
  findObjectUseCase,
  upsertUseCase,
} from "../../../usecases/object";
import withRouter from "../../../withRouter";
import BaseListPage from "../../../base/BaseListPage";
import { InfiniteScroll, Button } from "nq-component";
import Search from "../../../components/Search";
import Table from "../../../components/Table";
import CardView from "../../../components/common/CardView";
import OBRequestPresenter from "./OBRequestPresenter";
import InputFactory from "../../../components/InputFactory";
import DateRangePicker from "../../../components/common/DateRangePicker";

class OBRequestPage extends BaseListPage {
  constructor(props) {
    super(props);
    this.state = {
      objects: [],
      limit: 10,
      current: 1,
      count: 0,
    };
    this.presenter = new OBRequestPresenter(
      this,
      findObjectUseCase(),
      countObjectUseCase(),
      deleteObjectUseCase(),
      upsertUseCase()
    );
  }

  getCollectionName() {
    return "ob_requests";
  }

  onClickPagination(page) {
    this.presenter.setCurrentPage(page);
  }

  setObjects(objects) {
    this.setState({ objects });
  }

  setCurrent(current) {
    this.setState({ current });
  }

  handleAddRequest() {
    this.navigateTo(`/form/${this.getCollectionName()}`);
  }

  async handleDeleteData(data) {
    await this.presenter.deleteObjectUseCase.execute(this.getCollectionName(), data.id);
    this.refetchData();
  }

  async handleEditData(id) {
    this.navigateTo(`/form/${this.getCollectionName()}/${id}`);
    // this.refetchData();
  }

  handleViewObject(object){
    this.navigateTo(`/form/${this.getCollectionName()}/${object.id}`, {isViewMode: true});
  }

  async refetchData() {
    const objects = await this.presenter.getObjects();
    return objects;
  }

  render() {
    const { objects, loading, count, limit, current } = this.state;

    console.log("OBJECTSS", objects);

    const schema = this.getSchema(this.getCollectionName());
    if (!schema) return <h1>no schema</h1>;

    const includeLabel = Object.keys(schema.fields).filter(
      (fields) =>
      fields !== "createdAt" &&
        fields !== "destination" &&
        fields !== "purpose" &&
        fields !== "status" 
    );

    return (
      <>
        <div className="overflow-auto" style={{ marginTop: "5rem" }}>
          <InfiniteScroll className="h-100" loadMore={this.loadMore.bind(this)}>
            <div className="p-3 p-lg-4">
              <div
                className="d-flex mb-4"
                style={{ borderBottom: "1.5px solid #d3d3d3" }}
              >
                <p style={{ fontSize: ".9rem", color: "rgba(0, 0, 0, .45)" }}>
                  You are here: Home {">"} ReferenceTable {">"}{" "}
                  <span
                    style={{ fontSize: "1rem", color: "rgba(0, 0, 0, .70)" }}
                  >
                    {schema.label}
                  </span>
                </p>
              </div>

              <div className="mt-4">

              <CardView style={{ borderRadius: 0}}>
                <div className="row align-items-center">
                  <div className="col-md-6 d-flex align-items-center">
                    <DateRangePicker
                      width="100%"
                      fields={["createdAt", "updatedAt", ""]}
                      onFilter={(filterObj) => {
                        try {
                          const update = new Date(filterObj.updatedAt.$lte);
                          update.setDate(update.getDate() + 1);
                          const formattedDate = update
                            .toISOString()
                            .split("T")[0];
                          const filterStartDate = {
                            createdAt: {
                              $lte: formattedDate,
                              $gte: filterObj.createdAt.$gte,
                            },
                          };
                          this.searchSubmit(filterStartDate);
                          this.setState({ filters: filterStartDate });
                        } catch (e) {
                          this.searchSubmit({});
                          this.setState({ filters: {} });
                        }
                      }}
                    />
                  </div>
                  <div className="col-md-6 d-flex align-items-center">
                    {Object.keys(schema.filters || {})
                      .filter((field) => field !== "employee")
                      .map((field) => {
                        let { type, ...options } = schema.filters[field];
                        return (
                          <div key={field} style={{ width: "100%" }}>
                            <InputFactory
                              className="ms-1"
                              type={type}
                              field={field}
                              where={{}}
                              onChange={this.onChangeFilter.bind(this, type)}
                              {...options}
                            />
                          </div>
                        );
                      })}
                  </div>
                </div>
              </CardView>
              </div>

              <div
                style={{
                  marginTop: "20px",
                  width: "100%",
                }}
              >
                <CardView style={{ borderRadius: 0 }}>
                  <div className="d-flex align-items-center  justify-content-center">
                    <h4 className="text-primary">{schema.label}</h4>
                    <div
                      className="d-flex gap-2"
                      style={{ marginLeft: "auto" }}
                    >
                      <div className="p-0">
                        <Button onClick={this.handleAddRequest.bind(this)}>
                          <i class="bi bi-plus"></i> Add Request
                        </Button>
                      </div>
                    </div>
                  </div>
                </CardView>
              </div>

              <Table
               viewObject={this.handleViewObject.bind(this)}
                // objectId={this.handleDeleteData.bind(this)}
                // editId={this.handleEditData.bind(this)}
                progress={loading}
                refetch={this.refetchData.bind(this)}
                fields={schema.fields}
                objects={objects}
                collection={schema}
                count={count}
                limit={limit}
                current={current}
                loadPagination={this.onClickPagination.bind(this)}
                actionsList={[
                  {
                    label: <i className="bi bi-three-dots-vertical" />,
                    actionType: "OB Request",
                  },
                ]}
                excludeFields={Object.keys(schema.fields).reduce(
                  (acc, key) => {
                    const options = schema.fields[key];
                    if (options.read === false) {
                      acc.push(key);
                    }
                    switch (options._type || options.type) {
                      case "Relation":
                      
                      case "Object":
                      case "File":
                        acc.push(key);
                        break;
                      default:
                    }
                    return acc;
                  },
                  ["id", "Created At", "Updated At", ...includeLabel]
                )}
              />
            </div>
          </InfiniteScroll>
        </div>
      </>
    );
  }
}

export default withRouter(OBRequestPage);
